// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2375":"3d4b5622","7209":"80b02460"}[chunkId] + ".chunk.css";
};